// Activation tracking for the Dashboard "get started" checklist. Records which
// key areas a user has visited/used so the checklist reflects real progress.
// Now persisted server-side (per user) so progress follows the user across
// devices, with localStorage as an instant local cache + offline fallback.
import { api } from "@/lib/api";

const KEY = "erio_activation_v1";

export const getActivation = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

export const markActivation = (k) => {
  const a = getActivation();
  if (!a[k]) {
    a[k] = true;
    try {
      localStorage.setItem(KEY, JSON.stringify(a));
    } catch {
      /* ignore */
    }
    try {
      window.dispatchEvent(new CustomEvent("erio-activation"));
    } catch {
      /* ignore */
    }
  }
  // Sync to the server (idempotent) so adoption is tracked centrally.
  try {
    api.post(`/activation/${k}`).catch(() => {});
  } catch {
    /* ignore */
  }
};

// Pull server-recorded activation and merge into the local cache (call on load).
export const syncActivationFromServer = async () => {
  try {
    const { data } = await api.get("/activation");
    const a = getActivation();
    let changed = false;
    (data.keys || []).forEach((k) => {
      if (!a[k]) {
        a[k] = true;
        changed = true;
      }
    });
    if (changed) {
      try {
        localStorage.setItem(KEY, JSON.stringify(a));
      } catch {
        /* ignore */
      }
      try {
        window.dispatchEvent(new CustomEvent("erio-activation"));
      } catch {
        /* ignore */
      }
    }
  } catch {
    /* ignore */
  }
};

// Map a route path to its activation key (used by the global route tracker).
export const activationKeyForPath = (path) => {
  if (path.startsWith("/risks")) return "risks";
  if (path.startsWith("/suppliers")) return "suppliers";
  if (path.startsWith("/signals")) return "signals";
  if (path.startsWith("/governance")) return "governance";
  return null;
};
